"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listingsResponseBody = void 0;
exports.listingsResponseBody = {
    facets: [
        {
            key: 'attributes.delivery_days',
            dynamicFacet: false,
            values: [
                {
                    interval: {
                        minimum: 0,
                        maximum: 1,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '2',
                },
                {
                    interval: {
                        minimum: 2,
                        maximum: 2,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '17',
                },
                {
                    interval: {
                        minimum: 3,
                        maximum: 3,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '17',
                },
                {
                    interval: {
                        minimum: 4,
                        maximum: 4,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '7',
                },
                {
                    interval: {
                        minimum: 5,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '79',
                },
            ],
        },
        {
            key: 'attributes.delivery_free',
            dynamicFacet: false,
            values: [
                {
                    value: 'false',
                    count: '100',
                },
                {
                    value: 'true',
                    count: '123',
                },
            ],
        },
        {
            key: 'attributes.delivery_express',
            dynamicFacet: false,
            values: [
                {
                    value: 'false',
                    count: '56',
                },
                {
                    value: 'true',
                    count: '67',
                },
            ],
        },
        {
            key: 'price',
            dynamicFacet: false,
            values: [
                {
                    interval: {
                        exclusiveMinimum: 0,
                        exclusiveMaximum: 10,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '43',
                },
                {
                    interval: {
                        minimum: 10,
                        maximum: 20,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '32',
                },
                {
                    interval: {
                        minimum: 20,
                        maximum: 50,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '28',
                },
                {
                    interval: {
                        minimum: 50,
                        maximum: 100,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '11',
                },
                {
                    interval: {
                        minimum: 100,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '9',
                },
            ],
        },
        {
            key: 'discount',
            dynamicFacet: false,
            values: [
                {
                    interval: {
                        minimum: 0.1,
                        maximum: 0.2,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '8',
                },
                {
                    interval: {
                        minimum: 0.2,
                        maximum: 0.3,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '9',
                },
                {
                    interval: {
                        minimum: 0.3,
                        maximum: 0.4,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '1',
                },
                {
                    interval: {
                        minimum: 0.4,
                        maximum: 0.5,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '2',
                },
                {
                    interval: {
                        exclusiveMinimum: 0,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '12',
                },
            ],
        },
        {
            key: 'attributes.personalisable',
            dynamicFacet: false,
            values: [
                {
                    value: 'false',
                    count: '113',
                },
                {
                    value: 'true',
                    count: '10',
                },
            ],
        },
        {
            key: 'attributes.allows_gift_wrap',
            dynamicFacet: false,
            values: [
                {
                    value: 'false',
                    count: '85',
                },
                {
                    value: 'true',
                    count: '38',
                },
            ],
        },
        {
            key: 'attributes.made_in_britain',
            dynamicFacet: false,
            values: [
                {
                    value: 'false',
                    count: '50',
                },
                {
                    value: 'true',
                    count: '73',
                },
            ],
        },
        {
            key: 'attributes.delivery_zones',
            dynamicFacet: false,
            values: [
                {
                    interval: {
                        minimum: 1,
                        maximum: 1,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '123',
                },
                {
                    interval: {
                        minimum: 2,
                        maximum: 2,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '100',
                },
                {
                    interval: {
                        minimum: 4,
                        maximum: 4,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '61',
                },
                {
                    interval: {
                        minimum: 5,
                        maximum: 5,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '57',
                },
                {
                    interval: {
                        minimum: 6,
                        maximum: 6,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '60',
                },
                {
                    interval: {
                        minimum: 7,
                        maximum: 7,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '46',
                },
                {
                    interval: {
                        minimum: 8,
                        maximum: 8,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '47',
                },
                {
                    interval: {
                        minimum: 9,
                        maximum: 9,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '87',
                },
                {
                    interval: {
                        minimum: 10,
                        maximum: 10,
                    },
                    minValue: 0,
                    maxValue: 0,
                    count: '90',
                },
            ],
        },
    ],
    metadata: {
        attributionToken: 'hwHwhgoMCJD0zsIGEKj9s78BEAEaJDY4NzgyNjA3LTAwMDAtMjc3Yi05ZjFhLWFjM2ViMTU4NTljOCoFMTIzNDUyMKjlqi2Ovp0V1LKdFcLwnhWjgJcit7eMLcXL8xea7sYwkPeyMI6RyTCb1rctmNa3LToOZGVmYXVsdF9zZWFyY2hIAWgBegJ3YQ',
        filter: '((attributes.delivery_free: ANY("true")))',
    },
    pagination: {
        currentPage: 1,
        offset: 0,
        pageSize: 10,
        resultsReturnedThisPage: 10,
        totalResults: 123,
        totalPages: 2,
    },
    products: [
        {
            title: 'Organic Banana Powder 250g Gut Health Energy Digestion UK Certified Organic By Soil Association',
            available: true,
            partner: {
                shortcode: 'ausha',
                name: 'Ausha',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/ausha',
                        rel: '/ausha',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/ausha/product/organic-banana-powder-250g-energy-face',
                    rel: '/ausha/product/organic-banana-powder-250g-energy-face',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Organic Banana Powder 250g Gut Health Energy Digestion UK Certified Organic By Soil Association',
                    href: 'https://cdn.notonthehighstreet.com/fs/75/fc/4dec-f82b-4195-b6e9-053edd576bff/{size}_organic-banana-powder-250g-energy-face.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            attributes: {
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: [
                        'food & drink',
                        'food & drink > food supplements',
                        'food & drink > food supplements > protein powders',
                    ],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['Ausha'],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2021-09-10 12:25:31.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [1],
                    searchable: true,
                    indexable: true,
                },
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: [
                        '/christmas',
                        '/christmas/gifts-by-price',
                        '/christmas/gifts-by-price/christmas-gifts-under-20',
                        '/christmas/gifts-by-price/gifts-under-25',
                        '/christmas/gifts-by-price/gifts-under-30',
                        '/fathers-day',
                        '/fathers-day/free-delivery',
                        '/fathers-day/gifts-by-price',
                        '/fathers-day/gifts-by-price/gifts-under-25',
                        '/fathers-day/gifts-by-price/gifts-under-40',
                        '/fathers-day/view-all-fathers-day-gifts',
                        '/food-drink',
                        '/food-drink/baked-goods',
                        '/food-drink/food-supplements',
                        '/food-drink/sauces-seasonings',
                        '/food-drink/sauces-seasonings/mustards-seasonings',
                        '/food-drink/view-all-food-drink',
                        '/gifts',
                        '/gifts/gifts-by-price',
                        '/gifts/gifts-by-price/gifts-under-10',
                        '/gifts/gifts-by-price/gifts-under-15',
                        '/gifts/gifts-by-price/gifts-under-20',
                        '/gifts/gifts-by-price/gifts-under-25',
                        '/gifts/gifts-by-price/gifts-under-30',
                        '/gifts/gifts-by-price/gifts-under-40',
                        '/gifts/gifts-by-price/gifts-under-50',
                        '/gifts/gifts-by-price/gifts-under-75',
                        '/gifts/shop-by-personality',
                        '/gifts/shop-by-personality/for-gym-lovers',
                        '/gifts/shop-by-profession',
                        '/gifts/shop-by-profession/for-personal-trainers',
                        '/gifts/view-all-gifts',
                        '/themes',
                        '/themes/curated-gifts',
                        '/themes/gifts',
                        '/themes/gifts/free-delivery-gifts',
                        '/themes/gifts/gifts-under-30',
                    ],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['ausha'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 995,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 995,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 1851,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 1224,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 1274,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 995,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 1851,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 1224,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 1274,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 0,
            code: 1072494,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Bananas Print, Food Illustration Art',
            available: true,
            partner: {
                shortcode: 'animato',
                name: 'Animato',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/animato',
                        rel: '/animato',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/animato/product/bananas-print-food-illustration-art',
                    rel: '/animato/product/bananas-print-food-illustration-art',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Bananas Print, Food Illustration Art',
                    href: 'https://cdn.notonthehighstreet.com/fs/7c/25/06ec-ca56-465a-90a3-d8f935719d3f/{size}_bananas-print-food-illustration-art.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: true,
            lowCommitmentProductType: 'low commitment product',
            attributes: {
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [3],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: ['home & garden', 'home & garden > artwork', 'home & garden > artwork > prints'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['Animato'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: [
                        '/art',
                        '/art/posters-prints',
                        '/art/posters-prints/digital-prints',
                        '/art/posters-prints/view-all',
                        '/art/view-all',
                    ],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['animato'],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2023-12-15 10:17:15.000 Z'],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 1200,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 1200,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 2232,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 1476,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 1536,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 1200,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 2232,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 1476,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 1536,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 0,
            code: 1354463,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Organic Jackfruit Powder 250g And Organic Banana Powder250g Combo Pack',
            available: true,
            partner: {
                shortcode: 'ausha',
                name: 'Ausha',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/ausha',
                        rel: '/ausha',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/ausha/product/organic-superfood-powders-gift-pack',
                    rel: '/ausha/product/organic-superfood-powders-gift-pack',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Organic Jackfruit Powder 250g And Organic Banana Powder250g Combo Pack',
                    href: 'https://cdn.notonthehighstreet.com/fs/49/ee/68c9-18e7-4bd2-aeb8-9b8637ef6156/{size}_organic-gut-health-superfood-powders-wellness-gift-pack.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            attributes: {
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: ['/food-drink', '/food-drink/food-supplements', '/food-drink/view-all-food-drink'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['ausha'],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: [
                        'food & drink',
                        'food & drink > food supplements',
                        'food & drink > food supplements > superfood powders',
                    ],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2025-03-19 05:37:40.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [1],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['Ausha'],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 1795,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 1795,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 3339,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2208,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2298,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 1795,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 3339,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2208,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2298,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 0,
            code: 1488255,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Banana Fruit Print',
            available: true,
            partner: {
                shortcode: 'stcreativedesigns',
                name: 'STCreativedesigns',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/stcreativedesigns',
                        rel: '/stcreativedesigns',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/stcreativedesigns/product/banana-fruit-print',
                    rel: '/stcreativedesigns/product/banana-fruit-print',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Banana Fruit Print',
                    href: 'https://cdn.notonthehighstreet.com/fs/e4/bb/62c2-f3fa-4de3-8b25-bb2f46c71f50/{size}_banana-repeat-print.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            attributes: {
                pim_product_type: {
                    text: [
                        'home & garden',
                        'home & garden > artwork',
                        'home & garden > artwork > drawings & illustrations',
                    ],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2020-10-13 17:20:25.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [3],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['STCreativedesigns'],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['stcreativedesigns'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: [
                        '/art',
                        '/art/contemporary-art',
                        '/art/contemporary-art/food-drink',
                        '/art/contemporary-art/view-all',
                        '/art/drawings-and-illustrations',
                        '/art/posters-prints',
                        '/art/posters-prints/view-all',
                        '/art/view-all',
                        '/sale',
                        '/sale/prints-art-sale',
                        '/sale/prints-art-sale/drawings-illustrations',
                        '/sale/prints-art-sale/posters-prints',
                        '/sale/sale-by-price',
                        '/sale/sale-by-price/under-100',
                        '/sale/sale-by-price/under-20',
                        '/sale/sale-by-price/under-30',
                        '/sale/sale-by-price/under-40',
                        '/sale/sale-by-price/under-60',
                        '/sale/sale-by-price/under-80',
                        '/sale/sale-under-20',
                        '/sale/sale-under-25',
                        '/sale/sale-with-express-delivery',
                        '/sale/sale-with-free-delivery',
                        '/sale/view-all-sale-items',
                        '/sale/view-all-sale-items/art',
                    ],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 1200,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 1200,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 2232,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 1476,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 1536,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 2000,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 3720,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2460,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2560,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 40,
            code: 959685,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Handmade Mosaic Disco Ball Effect Banana',
            available: true,
            partner: {
                shortcode: 'prettylittlepresents',
                name: 'Pretty Little Presents',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/prettylittlepresents',
                        rel: '/prettylittlepresents',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/prettylittlepresents/product/handmade-mosaic-disco-ball-effect-banana',
                    rel: '/prettylittlepresents/product/handmade-mosaic-disco-ball-effect-banana',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Handmade Mosaic Disco Ball Effect Banana',
                    href: 'https://cdn.notonthehighstreet.com/fs/86/1f/a46c-9e26-4ed9-9d4b-a6fc18cfd32c/{size}_handmade-mosaic-disco-ball-effect-banana.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            attributes: {
                delivery_days: {
                    numbers: [15],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['prettylittlepresents'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: [
                        'home & garden',
                        'home & garden > decorative accessories',
                        'home & garden > decorative accessories > decor',
                        'home & garden > decorative accessories > decor > ornaments',
                    ],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: [
                        '/home',
                        '/home/home-accessories',
                        '/home/home-accessories/decorative-accessories',
                        '/home/home-accessories/decorative-accessories/ornaments',
                        '/home/view-all-home',
                    ],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['Pretty Little Presents'],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2024-02-19 13:16:50.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 2295,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 2295,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 4269,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2823,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2938,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 2295,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 4269,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2823,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2938,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 0,
            code: 1373166,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Pink And Green Banana Leaves Art Print',
            available: true,
            partner: {
                shortcode: 'violetsprinthouse',
                name: 'Violets Print House',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/violetsprinthouse',
                        rel: '/violetsprinthouse',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/violetsprinthouse/product/pink-and-green-banana-leaves-art-print',
                    rel: '/violetsprinthouse/product/pink-and-green-banana-leaves-art-print',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Pink And Green Banana Leaves Art Print',
                    href: 'https://cdn.notonthehighstreet.com/fs/58/a4/1ec2-c8c4-4953-ae8f-b990a07120b4/{size}_pink-and-green-banana-leaves-art-print.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            attributes: {
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: [
                        '/art',
                        '/art/contemporary-art',
                        '/art/contemporary-art/modern-abstract',
                        '/art/contemporary-art/nature-landscape',
                        '/art/contemporary-art/view-all',
                        '/art/paintings',
                        '/art/posters-prints',
                        '/art/posters-prints/digital-prints',
                        '/art/posters-prints/giclee',
                        '/art/posters-prints/posters',
                        '/art/posters-prints/view-all',
                        '/art/view-all',
                    ],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['violetsprinthouse'],
                    searchable: true,
                    indexable: true,
                },
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [6],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2021-05-14 14:38:27.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: ['home & garden', 'home & garden > artwork', 'home & garden > artwork > prints'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['Violets Print House'],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 1800,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 1800,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 3348,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2214,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2304,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 1800,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 3348,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2214,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2304,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 0,
            code: 1032673,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Banana Food Art Print Kitchen Fruit Poster',
            available: true,
            partner: {
                shortcode: 'hollyfrancesca',
                name: 'Holly Francesca',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/hollyfrancesca',
                        rel: '/hollyfrancesca',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/hollyfrancesca/product/banana-food-art-print-kitchen-fruit-poster',
                    rel: '/hollyfrancesca/product/banana-food-art-print-kitchen-fruit-poster',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Banana Food Art Print Kitchen Fruit Poster',
                    href: 'https://cdn.notonthehighstreet.com/fs/76/aa/4a94-9b5f-48bf-b9f3-0593faaf88d7/{size}_banana-food-art-print-kitchen-fruit-poster.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            attributes: {
                category_listing_pages: {
                    text: [
                        '/art',
                        '/art/contemporary-art',
                        '/art/contemporary-art/food-drink',
                        '/art/contemporary-art/view-all',
                        '/art/view-all',
                        '/sale',
                        '/sale/prints-art-sale',
                        '/sale/sale-by-price',
                        '/sale/sale-by-price/under-100',
                        '/sale/sale-by-price/under-30',
                        '/sale/sale-by-price/under-40',
                        '/sale/sale-by-price/under-60',
                        '/sale/sale-by-price/under-80',
                        '/sale/sale-with-express-delivery',
                        '/sale/sale-with-free-delivery',
                        '/sale/view-all-sale-items',
                        '/sale/view-all-sale-items/art',
                        '/whats-new',
                        '/whats-new/new-in-prints-art',
                        '/whats-new/whatsnew',
                    ],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['hollyfrancesca'],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['Holly Francesca'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [6],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: [
                        'home & garden',
                        'home & garden > artwork',
                        'home & garden > artwork > drawings & illustrations',
                    ],
                    searchable: true,
                    indexable: true,
                },
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2025-04-28 09:54:47.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 2240,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 2240,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 4166,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2755,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2867,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 2800,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 5208,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 3444,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 3584,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 20,
            code: 1503193,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Banana Fruit Tree Gift',
            available: true,
            partner: {
                shortcode: 'thegluttonousgardener',
                name: 'The Gluttonous Gardener',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/thegluttonousgardener',
                        rel: '/thegluttonousgardener',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/thegluttonousgardener/product/banana-tree-gift',
                    rel: '/thegluttonousgardener/product/banana-tree-gift',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Banana Fruit Tree Gift',
                    href: 'https://cdn.notonthehighstreet.com/fs/21/5b/e083-05a6-4b67-a1b8-2df547fdd0f4/{size}_banana-tree-gift.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            ratings: {
                averageRating: 4,
                ratingCount: 0,
                ratingHistogram: [],
            },
            attributes: {
                personalisable: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2016-08-01 12:33:18.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [2],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['The Gluttonous Gardener'],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['thegluttonousgardener'],
                    searchable: true,
                    indexable: true,
                },
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: [
                        '/fathers-day',
                        '/fathers-day/fathers-day-categories',
                        '/fathers-day/fathers-day-categories/all-fathers-day-gifts',
                        '/fathers-day/fathers-day-categories/inspiration',
                        '/fathers-day/fathers-day-categories/inspiration/new-hobbies',
                        '/fathers-day/free-delivery',
                        '/fathers-day/inspiration',
                        '/fathers-day/inspiration/new-hobbies',
                        '/fathers-day/personalised-gifts',
                        '/fathers-day/view-all-fathers-day-gifts',
                        '/garden',
                        '/garden/gardening',
                        '/garden/gardening/plants',
                        '/garden/gardening/trees',
                        '/home',
                        '/home/home-accessories',
                        '/home/home-accessories/flowers-plants',
                        '/home/home-accessories/flowers-plants/plants-trees',
                        '/home/home-accessories/flowers-plants/plants-trees/plants',
                        '/home/personalised',
                        '/home/view-all-home',
                    ],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: [
                        'home & garden',
                        'home & garden > garden & outdoors',
                        'home & garden > garden & outdoors > garden plants & seeds',
                        'home & garden > garden & outdoors > garden plants & seeds > fruit & vegetable plants',
                    ],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 4895,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 4895,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 9105,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 6021,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 6266,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 4895,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 9105,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 6021,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 6266,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 0,
            code: 614221,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Indoor Banana Plant Gift Crate',
            available: true,
            partner: {
                shortcode: 'thegluttonousgardener',
                name: 'The Gluttonous Gardener',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/thegluttonousgardener',
                        rel: '/thegluttonousgardener',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/thegluttonousgardener/product/indoor-banana-plant-gift-crate',
                    rel: '/thegluttonousgardener/product/indoor-banana-plant-gift-crate',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Indoor Banana Plant Gift Crate',
                    href: 'https://cdn.notonthehighstreet.com/fs/ec/c0/7be3-ac44-4ad5-9b02-0582e32ef776/{size}_indoor-banana-plant-gift-crate.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            attributes: {
                allows_gift_wrap: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                partner_shortcode: {
                    text: ['thegluttonousgardener'],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: [
                        'home & garden',
                        'home & garden > flowers & house plants',
                        'home & garden > flowers & house plants > real flowers & house plants',
                        'home & garden > flowers & house plants > real flowers & house plants > house plants',
                    ],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: [
                        '/home',
                        '/home/home-accessories',
                        '/home/home-accessories/flowers-plants',
                        '/home/home-accessories/flowers-plants/plants-trees',
                        '/home/home-accessories/flowers-plants/plants-trees/plants',
                        '/home/view-all-home',
                    ],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [2],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2022-07-08 16:19:08.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['The Gluttonous Gardener'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 4895,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 4895,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 9105,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 6021,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 6266,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 4895,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 9105,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 6021,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 6266,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 0,
            code: 1201146,
            isExpandedSearch: false,
            isSponsored: false,
        },
        {
            title: 'Banana And Vase Art Print Watercolour Pastel Poster',
            available: true,
            partner: {
                shortcode: 'hollyfrancesca',
                name: 'Holly Francesca',
                links: [
                    {
                        href: 'https://www.public.shared.qa.noths.com/hollyfrancesca',
                        rel: '/hollyfrancesca',
                    },
                ],
            },
            links: [
                {
                    href: 'https://notonthehighstreet.com/hollyfrancesca/product/banana-vase-art-print-watercolour-pastel-poster',
                    rel: '/hollyfrancesca/product/banana-vase-art-print-watercolour-pastel-poster',
                },
            ],
            isNew: false,
            purchasable: true,
            freeDomesticDelivery: true,
            images: [
                {
                    title: 'Banana And Vase Art Print Watercolour Pastel Poster',
                    href: 'https://cdn.notonthehighstreet.com/fs/03/9c/f342-1533-4ba7-b468-1ad3965567e4/{size}_banana-vase-art-print-watercolour-pastel-poster.jpg',
                    gravity: 'north',
                },
            ],
            inventoryStatus: 'in_stock',
            lowCommitmentProductFlag: false,
            lowCommitmentProductType: 'not low commitment product',
            attributes: {
                partner_shortcode: {
                    text: ['hollyfrancesca'],
                    searchable: true,
                    indexable: true,
                },
                is_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                category_listing_pages: {
                    text: [
                        '/art',
                        '/art/contemporary-art',
                        '/art/contemporary-art/food-drink',
                        '/art/contemporary-art/view-all',
                        '/art/drawings-and-illustrations',
                        '/art/view-all',
                        '/sale',
                        '/sale/prints-art-sale',
                        '/sale/prints-art-sale/drawings-illustrations',
                        '/sale/sale-by-price',
                        '/sale/sale-by-price/under-100',
                        '/sale/sale-by-price/under-30',
                        '/sale/sale-by-price/under-40',
                        '/sale/sale-by-price/under-60',
                        '/sale/sale-by-price/under-80',
                        '/sale/sale-with-express-delivery',
                        '/sale/sale-with-free-delivery',
                        '/sale/view-all-sale-items',
                        '/sale/view-all-sale-items/art',
                    ],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_type: {
                    text: ['not low commitment product'],
                    searchable: true,
                    indexable: true,
                },
                partner_name: {
                    text: ['Holly Francesca'],
                    searchable: true,
                    indexable: true,
                },
                low_commitment_product_fl: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                actual_comms_rate: {
                    numbers: [0.25],
                    searchable: true,
                    indexable: true,
                },
                is_partner_active: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                inventory_status: {
                    text: ['in_stock'],
                    searchable: true,
                    indexable: true,
                },
                made_in_britain: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
                personalisable: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                image_gravity: {
                    text: ['north'],
                    searchable: true,
                    indexable: true,
                },
                delivery_days: {
                    numbers: [6],
                    searchable: true,
                    indexable: true,
                },
                published_at: {
                    text: ['2022-10-10 17:29:45.000 Z'],
                    searchable: true,
                    indexable: true,
                },
                pim_product_type: {
                    text: [
                        'home & garden',
                        'home & garden > artwork',
                        'home & garden > artwork > drawings & illustrations',
                    ],
                    searchable: true,
                    indexable: true,
                },
                allows_gift_wrap: {
                    text: ['false'],
                    searchable: true,
                    indexable: true,
                },
                delivery_free: {
                    text: ['true'],
                    searchable: true,
                    indexable: true,
                },
            },
            price: {
                amount: 2240,
                currency: 'GBP',
                exponent: 2,
            },
            prices: [
                {
                    amount: 2240,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 4166,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 2755,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 2867,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            preSalePrices: [
                {
                    amount: 2800,
                    currency: 'GBP',
                    exponent: 2,
                },
                {
                    amount: 5208,
                    currency: 'AUD',
                    exponent: 2,
                },
                {
                    amount: 3444,
                    currency: 'EUR',
                    exponent: 2,
                },
                {
                    amount: 3584,
                    currency: 'USD',
                    exponent: 2,
                },
            ],
            onSale: true,
            salePercentage: 20,
            code: 1234920,
            isExpandedSearch: false,
            isSponsored: false,
        },
    ],
    pinnedResults: 0,
    zeroExactResults: false,
};
